import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=733da0bf&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733da0bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733da0bf')) {
      api.createRecord('733da0bf', component.options)
    } else {
      api.reload('733da0bf', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=733da0bf&scoped=true&", function () {
      api.rerender('733da0bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/Admin.vue"
export default component.exports